import { Link } from 'react-router-dom';

export default function Footer() {
  const cols = [
    { title: 'Solutions', links: [{ label: 'Residential', to: '/residential' }, { label: 'Commercial', to: '#' }, { label: 'Multi-family', to: '#' }, { label: 'Storage & Battery', to: '#' }] },
    { title: 'Company', links: [{ label: 'About', to: '#' }, { label: 'Projects', to: '#' }, { label: 'Careers', to: '#' }, { label: 'Press', to: '#' }] },
    { title: 'Support', links: [{ label: 'Contact', to: '#' }, { label: 'FAQ', to: '#' }, { label: 'Warranty', to: '#' }, { label: 'Monitoring', to: '#' }] },
    { title: 'Legal', links: [{ label: 'Privacy', to: '#' }, { label: 'Terms', to: '#' }, { label: 'Accessibility', to: '#' }, { label: 'Cookies', to: '#' }] },
  ];
  return (
    <footer className="bg-[#EDF1F5] pt-20 pb-10">
      <div className="container-x">
        <div className="grid grid-cols-12 gap-8 pb-16">
          <div className="col-span-12 md:col-span-4">
            <div className="flex items-center gap-2">
              <i className="ri-sun-line text-solar-green text-2xl"></i>
              <span className="display-font font-semibold text-[18px] text-solar-ink">Sunfield</span>
            </div>
            <p className="mt-5 text-solar-muted text-sm leading-relaxed max-w-[320px]">
              Clean, reliable solar infrastructure for the homes and businesses building a cleaner future.
            </p>
          </div>
          {cols.map((c) => (
            <div key={c.title} className="col-span-6 md:col-span-2">
              <p className="text-solar-ink text-sm font-semibold mb-4">{c.title}</p>
              <ul className="space-y-3">
                {c.links.map((l) => (
                  <li key={l.label}>
                    {l.to.startsWith('/') ? (
                      <Link to={l.to} className="text-solar-muted text-sm hover:text-solar-ink transition-colors">{l.label}</Link>
                    ) : (
                      <a href={l.to} className="text-solar-muted text-sm hover:text-solar-ink transition-colors">{l.label}</a>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="pt-8 border-t border-solar-divider flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 text-xs text-solar-muted">
          <p>© 2026 Sunfield Energy Inc. All rights reserved.</p>
          <div className="flex items-center gap-5">
            <a href="#" className="w-6 h-6 flex items-center justify-center hover:text-solar-ink"><i className="ri-instagram-line"></i></a>
            <a href="#" className="w-6 h-6 flex items-center justify-center hover:text-solar-ink"><i className="ri-linkedin-line"></i></a>
            <a href="#" className="w-6 h-6 flex items-center justify-center hover:text-solar-ink"><i className="ri-youtube-line"></i></a>
          </div>
        </div>
      </div>
    </footer>
  );
}